export default "assets/images/texture-menu-19281bb2.png";